import { render, staticRenderFns } from "./JobHorizontalCard.vue?vue&type=template&id=7ffd582a&scoped=true&"
import script from "./JobHorizontalCard.vue?vue&type=script&lang=js&"
export * from "./JobHorizontalCard.vue?vue&type=script&lang=js&"
import style0 from "./JobHorizontalCard.vue?vue&type=style&index=0&id=7ffd582a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd582a",
  null
  
)

export default component.exports